import { cn } from '@/lib/utils';

export default function DownloadIcon({ className }: { className?: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={cn('size-5', className)} viewBox="0 0 18 18" fill="none">
            <g clipPath="url(#clip0_8542_4498)">
                <path
                    d="M3 12.75V14.25C3 14.6478 3.15804 15.0294 3.43934 15.3107C3.72064 15.592 4.10218 15.75 4.5 15.75H13.5C13.8978 15.75 14.2794 15.592 14.5607 15.3107C14.842 15.0294 15 14.6478 15 14.25V12.75"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M5.25 8.25L9 12L12.75 8.25" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 3V12" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_8542_4498">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
